const TrendingItemSkeleton = ({ index }) => {
  return (
    <div className="flex items-start gap-4 p-4 bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700 animate-pulse">
      
      {/* Rank circle */}
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200" />

      {/* Content */}
      <div className="flex-1 min-w-0">
        {/* Author */}
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 rounded-full bg-gray-200" />
          <div className="h-3 w-24 bg-gray-200 rounded" />
        </div>

        {/* Text */}
        <div className="space-y-2 mb-3">
          <div className="h-4 w-full bg-gray-200 rounded" />
          <div className="h-4 w-3/4 bg-gray-200 rounded" />
        </div>

        {/* Meta */}
        <div className="flex gap-4">
          <div className="h-3 w-16 bg-gray-200 rounded" />
          <div className="h-3 w-20 bg-gray-200 rounded" />
        </div>
      </div>

      {/* Button */}
      <div className="h-8 w-16 bg-gray-200 rounded" />
    </div>
  );
};

export default TrendingItemSkeleton;